import { render, staticRenderFns } from "./Requisition.vue?vue&type=template&id=27a06b84&scoped=true"
import script from "./Requisition.vue?vue&type=script&lang=js"
export * from "./Requisition.vue?vue&type=script&lang=js"
import style0 from "./Requisition.vue?vue&type=style&index=0&id=27a06b84&prod&lang=css"
import style1 from "./Requisition.vue?vue&type=style&index=1&id=27a06b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a06b84",
  null
  
)

export default component.exports